import styled from 'styled-components';
import { titleMedium, text } from 'styles-js/mixins/typography';
import { fadeEllipsis } from 'styles-js/mixins/fade';

export const Card = styled.div`
  height: 310px;
  margin: 14px 3px;
  padding: 15px;
  display: flex;
  flex-direction: column;
  border: ${({ theme }) => theme.greyLine};

  @media (${({ theme }) => theme.underScreenSmall}) {
    height: 270px;
  }
`;
export const Banner = styled.div<{ $bannerUrl: string }>`
  background-image: url(${({ $bannerUrl }) => $bannerUrl});
  background-size: cover;
  background-position: center;
  margin: -15px -15px 20px;
  position: relative;
  height: 120px;
  @media (${({ theme }) => theme.underScreenSmall}) {
    height: 80px;
  }
`;
export const Body = styled.div`
  height: 100%;
  display: flex;
  flex-direction: column;
`;
export const Title = styled.h3`
  ${titleMedium}
  margin-bottom: 5px;
  max-height: calc(${({ theme }) => theme.fontLineHeightM} * 2);
  overflow: hidden;
`;
export const Text = styled.p`
  ${text}
  flex-grow: 1;
  max-height: calc(${({ theme }) => theme.fontLineHeightS} * 3);
  overflow: hidden;
  margin-bottom: 5px;
  position: relative;
  ::after {
    ${fadeEllipsis};
  }
`;
export const Description = styled(Text)`
  margin-bottom: auto;
`;
export const ReadMore = styled.span `
  margin-top: 20px;
`;
